import 'prop-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import { createSlice } from '@reduxjs/toolkit';
import { createSimpleSelector } from '@dbh/reselect-extra';
import _noop from 'lodash/noop';

/*
 *
 * Constants: `@dbh/redux-route-internals`.
 *
 */const REDUX_AND_SAGA_KEY="routeInternals";

/**
 * @typedef {string} WebcontrolsReference The `reference` field of a
 * "Navigation Menu" in the `admindev`.
 * @typedef {WebcontrolsReference[]} WebcontrolsReferences
 * @typedef {Object<{
 * webcontrolsReferences: WebcontrolsReferences
 * }>} AdminDependencies Data from the `admindev` required to render a page.
 */const adminDependenciesPropType=_noop;

const initialState={reactRouterPageType:null,isPaginated:null,adminDependencies:null},routeInternalsReducer=createSlice({name:REDUX_AND_SAGA_KEY,initialState,reducers:{reactRouterMatch:withConformsTo("reactRouterMatch",[],(a,b)=>{const{payload:{PAGE_TYPE:c,isPaginated:d,adminDependencies:e}}=b;return {...a,reactRouterPageType:c,isPaginated:d,adminDependencies:e}})}});const {reactRouterMatch}=routeInternalsReducer.actions;var reducer = routeInternalsReducer.reducer;

/**
 * @typedef {import('./types').AdminDependencies} AdminDependencies
 */const selectRouteInternals=a=>a?a[REDUX_AND_SAGA_KEY]:void 0;/**
 * Returns a selector that returns the `admindev` dependencies.
 * @return {AdminDependencies} .
 */const makeSelectAdminDependencies=()=>createSimpleSelector(selectRouteInternals,["adminDependencies"]);

export { REDUX_AND_SAGA_KEY, adminDependenciesPropType, makeSelectAdminDependencies, reactRouterMatch, reducer as routeInternalsReducer, selectRouteInternals };
